<template>
    <div class=""
        :data-component-name="$options.name"
    >
        <q-field mask="date"
            :value="$attrs.value"
            :rules="[isCustomRequired]"
            label="Dates"
            :dense="dense"
            :filled="filled"
            :error="error"
            :bottom-slots="false"
            :outlined="outlined"
            :borderless="borderless"
        >
            <template v-slot:control>
                <div class="self-center full-width no-outline" tabindex="0" style="padding-top: 4px;">
                    <span v-bind:key="index" v-for="(date, index) in selectedDates">
                        <q-chip
                            color="blue"
                            text-color="white"
                            v-if="typeof date === 'string'"
                            size="sm"
                            :removable="!$attrs.readonly"
                            @remove="log({index: index, values: $attrs.value}); $attrs.value.splice(index, 1)">
                            {{ date }}
                        </q-chip>
                        <q-chip
                            color="blue"
                            text-color="white"
                            v-else
                            size="sm"
                            :removable="!$attrs.readonly"
                            @remove="log({index: index, values: $attrs.value}); $attrs.value.splice(index, 1)">
                            {{ date.from }} au {{ date.to }}
                        </q-chip>
                    </span>
                </div>
            </template>
            <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale" @show="setMonth()" v-if="!$attrs.readonly" :breakpoint="100">
                <div>
                    <q-date
                        :first-day-of-week="$generalSettings.settings.firstDayOfWeek"
                        ref="myDateRangesPicker"
                        minimal
                        v-bind="$attrs"
                        mask="YYYY-MM-DD"
                        :options="optionsFn"
                        @input="dateSet($event)"
                        :default-year-month="defaultyearmonth"
                    >
                    </q-date>
                </div>
            </q-popup-proxy>
        </q-field>
    </div>
</template>

<script>
    import QDate from 'quasar'
    import moment from 'moment';

    export default {
        name: "DatePicker",
        extends: QDate,
        props: {
            outlined: {
                type: Boolean,
                default: false
            },
            error: {
                type: Boolean,
                default: false
            },
            borderless: {
                type: Boolean,
                default: false
            },
            dense: {
                type: Boolean,
                default: true
            },
            filled: {
                type: Boolean,
                default: true
            },
            projectShift: {
                type: Object,
            },
            dateFrom: {
                type: [Date, Object],
                default() {
                    let date=new Date();
                    return {date}
                }
            },
            selectedDates: {
                type: Array,
                default(){ return [] }
            }
        },
        data(){
            return {
                // defaultyearmonth: null
                defaultyearmonth: new Date(window.currentDate).getFullYear()+"/"+(new Date(window.currentDate).getMonth()+1).pad(2)
            }
        },
        mounted(){
            if(window.currentDate && this.selectedDates.length==0){
                let date=new Date(window.currentDate)
                this.defaultyearmonth=date.getFullYear()+"/"+(date.getMonth()+1).pad(2)
            }
        },
        computed:  {
            daysOfWeek(){
                let days=new Array(), ctr=0;
                if(this.projectShift){
                    if(this.projectShift.Sun) days.push(ctr);ctr++;
                    if(this.projectShift.Mon) days.push(ctr);ctr++;
                    if(this.projectShift.Tue) days.push(ctr);ctr++;
                    if(this.projectShift.Wed) days.push(ctr);ctr++;
                    if(this.projectShift.Thu) days.push(ctr);ctr++;
                    if(this.projectShift.Fri) days.push(ctr);ctr++;
                    if(this.projectShift.Sat) days.push(ctr);ctr++;
                }else{
                    days=[0,1,2,3,4,5,6]
                }
                return days
            }
        },
        methods: {
            isCustomRequired(val){
                if(val && val.length==0) return false;
                return true;
            },
            setMonth(){
                // this.$refs["myDateRangesPicker"].setCalendarTo(this.dateFrom.getFullYear(), this.dateFrom.getMonth()+1)
            },
            dateIsValid(val) {
                if(!val) return
                if(!moment(val, 'YYYY-MM-DD',true).isValid() && !this.$attrs.multiple) return '* Format de date invalide'
            },
            dateSet(val) {
                if(val) val=val.sort(function(a,b){
                            let aDate=a, bDate=b;
                            if(a.from){
                                aDate=a.from
                            }
                            if(b.from){
                                bDate=b.from
                            }
                            return new Date(aDate)-new Date(bDate)
                        })

                this.$emit('input', val);
                if(!this.$attrs.multiple) this.$refs.qDateProxy.hide();
            },
            optionsFn(date) {
                let myDate=new Date(date);
                return this.daysOfWeek.includes(myDate.getDay());
            },
            log(msg){
                console.log(msg)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .q-menu{
        min-width: auto !important;
    }
    .q-field--with-bottom {
        padding-bottom: inherit;
    }
</style>